export default __webpack_public_path__ + "static/media/front-left-wheel.cadf0adb.svg";